import Header from "../componentes/Header";

function GenerateTeams() {
    return(
        <Header/>
    )
}

export default GenerateTeams;